import ReportController from './report.controller';

export default class DayTripperReportController extends ReportController
{
	get endpoint() {
		return 'day-tripper';
	}

	get title() {
		return 'Day Tripper Pax Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/day-tripper.report.controller.js
 **/